import React from 'react';
import { Space } from 'antd';
import styles from './MetadataRow.less';
import LeadProductGroup from '@/components/Lead/LeadProductGroup';
import { LeadDetailsModel } from '@/typings/models/Lead';
import LeadState from '@/components/Lead/LeadState';
import LeadPriority from '@/components/Lead/LeadPriority';
import LeadAssigneeOverview from '@/components/Lead/LeadAssigneeOverview';
import LeadDealSize from '@/components/Lead/LeadDealSize';
import classNames from 'classnames';
import { EuroSymbolIcon } from '@/components/Icons/CustomReactIcons';

export interface MetadataRowProps {
  leadDetails: LeadDetailsModel;
}

const MetadataRow: React.FC<MetadataRowProps> = ({
                                                   leadDetails,
                                                 }) => {

  return (
    <div className={styles.metadataRow}>
      <Space size={[12, 6]} wrap>
        {/* Status */}
        <span className={styles.leadStateMetadataItem}>
          <LeadState isTable lead={leadDetails} />
        </span>

        {/* Assignee */}
        <div
          className={classNames(styles.metadataRowItem, styles.noPadding)}
        >
          <LeadAssigneeOverview showAssigneeName lead={leadDetails} />
        </div>

        {/* Product Group */}
        <span className={styles.metadataRowItem}>
          <LeadProductGroup
            value={leadDetails?.product_group?.id}
            lead={leadDetails}
          />
        </span>
        {/* Priority */}
        <span className={styles.metadataRowItem}>
          <LeadPriority
            value={leadDetails?.priority?.value}
            lead={leadDetails}
          />
        </span>
        <span
          className={classNames(styles.metadataRowItem, styles.dealSizeRow)}
        >
          <Space>
            <EuroSymbolIcon className={styles.dealSizeIcon}/>
            <LeadDealSize lead={leadDetails} />
          </Space>
        </span>
      </Space>
    </div>
  );
};

export default MetadataRow;
